import _defineProperty from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/objectSpread2.js";
var _objectSpread2;
import en_json from './en.json';
export default _objectSpread((_objectSpread2 = {
  route: {
    dashboard: 'Dashboard',
    home: 'home',
    system: 'System'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    profile: 'Profile',
    updatePwd: 'Modify Password',
    github: 'Github',
    screenfull: 'Screenfull',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'OKEY',
    errorAccount: 'Please enter the correct user name',
    errorPassword: 'The password can not be less than 5 digits',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    capCode: 'CAPTCHA'
  },
  button: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    cancel: 'Cancel',
    clear: 'Clear',
    back: 'Back',
    export: 'Export',
    save: 'Save',
    approve: 'Approve'
  },
  common: {
    mustSelectOne: 'Please select the record to operate!',
    deleteConfirm: 'Are you sure delete the record?',
    tooltip: 'Tooltip',
    warning: 'Warning',
    optionSuccess: 'success',
    uploadError: 'Upload Error',
    isRequired: ' is required',
    week: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun'
    }
  },
  店铺名称: "Shop Name",
  店铺LOGO: "Shop Logo",
  活动标题: "Activity Title",
  店铺: "Shop",
  活动内容: "Activity Remark",
  操作: "Option",
  查看: "Details",
  修改: "Modify",
  删除: "Delete",
  设备: "Equipment",
  预约消息: "Appointment Message",
  预约人: "Appointment Person",
  预约状态: "Appointment State",
  待确认: "TO CONFIRM",
  已确认: "CONFIRMED",
  已取消: "CANCEL",
  店铺地址: "Shop Address",
  营业开始时间: "Opening Hours",
  营业结束时间: "Closing Hours",
  联系电话: "Mobile",
  是否营业中: "is Opening",
  管理员: "Admin",
  营业执照: "Business License",
  商铺详情: "Shop Details",
  查看详情: "Show Detail",
  手机号已经存在: "The phone number already exists, please use a different one",
  添加店铺: "Add Shop",
  "无归属人": "No Owner",
  "历史归宿人": "Previous Owner",
  "历史归属人": "Historical Owner",
  "有": "Yes",
  "无": "No",
  "有无归属人": "Has Owner or Not",
  "正在运营店铺": "Operating Stores",
  "全部撤机店铺": "All Closed Stores",
  "未成交线索": "Unclosed Leads",
  "结算差额": "Settlement Difference",
  "店铺余额": "Store Balance",
  "结算单支付差额": "Payment Difference on Invoice",
  //7.30
  OKR目标: "OKR Target",
  "父任务(履约期目标)": "Parent Task (Contract Period Target)",
  "子目标": "Sub Target",
  "经理名称": "Manager Name",
  "代理子账号": "Agent Sub-Account",
  "履约日期": "Contract Date",
  "履约状态": "Contract Status",
  "履约中": "In Contract",
  "已锁号": "Locked",
  "新建目标": "Create New Target",
  "子账号": "Sub-Account",
  "签约日期": 'Sign Date',
  "履约期设备数": "Devices in Contract Period",
  "进度": "Progress",
  "目标": "Target",
  "已签约铺设": "Signed Installations",
  "目标名称": "Target Name",
  "目标名称不能为空": "Target name cannot be empty",
  "目标接收角色": "Target Recipient Role",
  "销售经理": "Sales Manager",
  "运维经理": "Operations Manager",
  "履约期目标时间": "Contract Period Target Time",
  "新建线索数": "New Leads Count",
  "履约设备数": "Contract Devices",
  "目标生成方式": "Target Creation Method",
  "父目标分解(履约期任务)": "Parent Target Breakdown (Contract Period Task)",
  "子目标时间": "Sub Target Time",
  "受账单结算周期影响，一周可能存在跨月情况，比如7月第5周跨7月和8月，所以以逻辑月为依据判断": "Due to billing cycles, a week may span across months. For example, the 5th week of July may overlap July and August. Therefore, logical months are used for judgment.",
  "履约期": "Contract Period",
  "锁号/已完成": "Locked / Completed",
  "签约设备数": "Signed Devices Count",
  "单台运营时长": "Single Device Operation Duration",
  "合同签约后的6个月开始，在任务执行期": "From 6 months after contract signing, within task execution period",
  "已完成代表在履约期内任务已完成，达到指定的履约设备数，比如要求100，实际≥100个": "‘Completed’ means the task was finished within the contract period, reaching the required number of devices. For example, required 100, actual ≥100.",
  "已锁号代表在履约期内任务未完成，比如要求100，实际完成60": "‘Locked’ means the task was not completed within the contract period. For example, required 100, actual 60.",
  "请选择一条信息": "Please select a record",
  "延长履约期": "Extend Contract Period",
  "代理员工名称": "Agent Employee Name",
  "履约效期": "Contract Validity Period",
  "yctip": "After extension, merchants can place orders and operations can install during the extended period",
  "上调履约设备数": "Increase Contract Devices",
  "分解目标": "Break Down Target",
  "最高目标数": "Maximum Targets",
  "已完成次数": "Completed Times",
  "完成率": "Completion Rate",
  "子目标完成情况": "Sub Target Status",
  "确定延长履约期": "Confirm extension of contract period???",
  "修改履约设备数": "Modify Contract Devices",
  "创建子账号": "Create Sub-Account",
  "履约完成状态": "Contract Completion Status",
  "确定修改履约设备数": "Confirm modification of contract devices",
  "履约期目标时间不能为空": "Contract period target time cannot be empty",
  "履约设备数不能为空": "Contract devices count cannot be empty",
  "子账号不能为空": "Sub-account cannot be empty",
  "提交成功": "Submitted successfully",
  "请选择": "Please select",
  "选择月": "Select Month",
  "子目标时间不能为空": "Sub target time cannot be empty",
  "新建线索数详情": "New Leads Count Details",
  "子目标日期": "Sub Target Date",
  "目标数": "Target Count",
  "完成情况": "Completion Status",
  "线索名称": "Lead Name",
  "线索电话": "Lead Phone",
  "线索地址": "Lead Address",
  "拜访状态": "Visit Status",
  "编辑新建线索数目标": "Edit New Leads Count Target",
  "当前单台运营时长/小时": "Current Single Device Duration / Hours",
  "编辑签约设备数目标": "Edit Signed Devices Target",
  "编辑单台运营时长目标": "Edit Single Device Duration Target",
  "签约设备数详情": "Signed Devices Details",
  "单台运营时长详情": "Single Device Duration Details",
  "WAIT_VISITE": "Pending Visit",
  "IN_DISCUSSION": "In Discussion",
  "HAVE_INTENTION": "Interested",
  "DONE_DEAL": "Signed",
  "DECLINED": "Declined",
  "地址": "Address",
  "小时": "Hour",
  "新建线索数不能为空": "New leads count cannot be empty",
  "签约设备数不能为空": "Signed devices count cannot be empty",
  "单台运营时长不能为空": "Single device duration cannot be empty",
  "关联子账号": "Linked Sub-Account",
  "跟进次数": "Follow-up Count",
  "合同编码": "Contract Code",
  "合同类型": "Contract Type",
  "所属组织": "Organization",
  "购买": "Purchase",
  "租赁": "Lease",
  "新建线索数导出xlsx": "Export New Leads Count.xlsx",
  "签约设备数导出xlsx": "Export Signed Devices.xlsx",
  "单台运营时长导出xlsx": "Export Single Device Duration.xlsx",
  "父任务导出xlsx": "Export Parent Task.xlsx",
  "子目标单台运行时长": "Sub Target Single Device Duration",
  "子任务线索数总和不能大于任务线索数": "Sum of sub-task leads cannot exceed task leads",
  "子任务设备数总和不能大于任务设备数": "Sum of sub-task devices cannot exceed task devices",
  "线索存量上限设置": "Lead Stock Limit Setting",
  "单个销售专员线索上限数量设置": "Lead Limit Setting per Sales Rep",
  "温馨说明：设置上限后，则所有销售专员无法超额新建线索；注意：不包含已签约开户的线索，不涉及子账号业务": "Note: After setting the limit, sales reps cannot exceed it when creating new leads. Signed and opened leads are not included, and sub-accounts are not involved.",
  "单个销售专员线索上限数量设置不能为空": "Lead limit per sales rep cannot be empty",
  "合同编号": "Contract Number",
  "签约金额": "Contract Amount",
  "合同导出xlsx": "Export Contract.xlsx"
}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, "\u6B63\u5728\u8FD0\u8425\u5E97\u94FA", "Operating Stores"), "\u5168\u90E8\u64A4\u673A\u5E97\u94FA", "All Closed Stores"), "\u672A\u6210\u4EA4\u7EBF\u7D22", "Unclosed Leads"), "合同下单时间", "Contract Order Time"), "设备安装时间", "Equipment Installation Time"), "合同状态", "Contract Status"), "httip", "Signed: A signed contract means the contract document has been uploaded\n\n" + "In Cooperation: The contract has been uploaded, and the order is waiting for installation;\n\n" + "Cooperation Completed: The contract has been uploaded, and the equipment has been installed;"), "运转分析", "Operation Analysis"), "总数", "Total"), "选择运维", "Select Operations"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, "设备运转良好，暂无空转记录", "The equipment is operating well, no idle records"), "店铺设备数据详情", "Store Equipment Data Details"), "查看明细", "View Details"), "请输入部门名称", "Please enter the department name")), en_json);